<template>
  <div class="flex flex-wrap items-center gap-1">
    <button
      v-for="(group, index) in groups"
      :key="`${group}-${index}`"
      type="button"
      class="min-w-10 cursor-pointer rounded-md border px-1.5 py-0.5 font-semibold tracking-wide transition-colors"
      :class="
        copied && copiedIndex === index
          ? 'border-primary-500 bg-primary-50 text-primary-700'
          : 'border-secondary-400 bg-white text-secondary-900 hover:bg-secondary-50'
      "
      :aria-label="`Copier ${group}`"
      :title="`Copier ${group}`"
      @click.stop="copyGroup(group, index)"
    >
      {{ group }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { useToast } from "~/composables/useToast";
import { splitIbanIntoGroups } from "@asap/shared/utils/iban2";

const props = defineProps<{
  iban: string;
}>();

const groups = computed(() => splitIbanIntoGroups(props.iban));
const copiedIndex = ref<number | null>(null);
const { copy, copied } = useClipboard();
const { addToastSuccess, addToastError } = useToast();

const copyGroup = async (group: string, index: number) => {
  try {
    await copy(group);
    copiedIndex.value = index;
    addToastSuccess({
      title: "Copié !",
      description: "Le texte a été copié dans le presse-papier.",
    });
  } catch {
    addToastError({
      title: "Impossible de copier le texte",
      description: "Vous devez probablement autoriser l'accès à votre presse-papier.",
    });
  }
};
</script>
